import { Navigation } from "@/components/layout/Navigation";
import Hero from "@/components/marketing/Hero";
import Footer from "@/components/layout/Footer";
import { PricingGrid } from "@/components/subscription/PricingGrid";
import { FeatureComparisonTable } from "@/components/subscription/FeatureComparisonTable";
import CTAButton from "@/components/marketing/CTAButton";

const Pricing = () => {
  return (
    <div className="min-h-screen">
      <Navigation showAuth={true} className="mt-4" />

      {/* Hero Section */}
      <Hero
        badge="The only tool you need to write better"
        headline={
          <>
            Simple pricing.{' '}
            <span className="font-serif font-medium italic text-primary">
              All batteries included.
            </span>
          </>
        }
        description="Whether you're just starting your writing journey, or already earn money from words, Arcitext has you covered."
        secondaryDescription="Start with a 7-day free trial"
      />

      {/* Pricing Cards */}
      <section className="pb-16 pt-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <PricingGrid
            recommendedTierId="solo"
            ctaLink="/?auth=signup"
            ctaText="Start Writing"
            useCTAButton={true}
          />
        </div>
      </section>

      {/* Feature Comparison Table */}
      <section className="py-16 bg-muted/20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-foreground mb-3">
              What's Included
            </h2>
            <p className="text-muted-foreground text-lg">
              All plans include full access to features. The only difference is usage limits.
            </p>
          </div>

          <div className="glass-card rounded-2xl overflow-hidden">
            <FeatureComparisonTable />
          </div>
          <div className="text-center mt-12">
            <CTAButton
              to="/?auth=signup"
              variant="default"
              size="lg"
            />
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-foreground text-center mb-12">
            Frequently Asked Questions
          </h2>

          <div className="space-y-8">
            <div className="glass-card p-6 rounded-2xl">
              <h3 className="text-lg font-semibold text-foreground mb-2">
                Can I try Arcitext before paying?
              </h3>
              <p className="text-muted-foreground">
                Never buy a pair of shoes without trying them on. Explore Arcitext with a full 7-day free trial, then upgrade to keep using AI features.
              </p>
            </div>

            <div className="glass-card p-6 rounded-2xl">
              <h3 className="text-lg font-semibold text-foreground mb-2">
                What happens to my data?
              </h3>
              <p className="text-muted-foreground">
                Your content and brand profiles are yours. We use them only to provide you with personalized feedback. You can delete your data anytime.
              </p>
            </div>

            <div className="glass-card p-6 rounded-2xl">
              <h3 className="text-lg font-semibold text-foreground mb-2">
                Is Arcitext not just generating text for me?
              </h3>
              <p className="text-muted-foreground">
                No, Arcitext puts human creativity front and center. We just give you an AI Assisted workflow, that helps you write better, and give you useful feedback as you go. Arcitext Chat can produce drafts for you, but doesn't remove your authorship or control.
              </p>
            </div>

            <div className="glass-card p-6 rounded-2xl">
              <h3 className="text-lg font-semibold text-foreground mb-2">
                Can I change plans anytime?
              </h3>
              <p className="text-muted-foreground">
                Yes! Upgrade or downgrade your plan anytime. Changes take effect on your next billing cycle, and you'll only pay the difference when upgrading.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Pricing;
